var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"8px"}},[_c('label',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.$t('settings.forms.formName'))+" ")]),_c('BFormInput',{staticClass:"mb-2",attrs:{"size":"sm","placeholder":_vm.$t('settings.forms.formName')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }